import { render, staticRenderFns } from "./StandardOverview.vue?vue&type=template&id=2c4ae538&scoped=true&"
import script from "./StandardOverview.vue?vue&type=script&lang=js&"
export * from "./StandardOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4ae538",
  null
  
)

export default component.exports